module.exports = __webpack_public_path__ + "static/media/ic_video_admin.cb75921d.svg";